import React from 'react';
import SEO from '../../components/SEO/SEO';
import SubServiceTemplate from '../../components/SubServiceTemplate/SubServiceTemplate';

const TechnicalSEO = () => {
  const pageData = {
    category: "TECHNICAL SEO",
    title: "Technical SEO Audits & Optimization",
    description: "Ensure search engines can crawl, index, and understand your website perfectly. Our technical SEO services fix critical issues that prevent your site from ranking.",
    ctaText: "Get a Free SEO Audit",
    ctaLink: "/contact",
    parentLink: "/services/seo",
    parentTitle: "SEO",

    features: [
      {"icon": "⚡", "title": "Site Speed Optimization", "description": "Comprehensive performance audits and optimization for faster load times."},
      {"icon": "🕷️", "title": "Crawl & Index Optimization", "description": "Ensure search engines can discover and index all important pages."},
      {"icon": "🏗️", "title": "Schema Markup", "description": "Structured data implementation for rich snippets and better SERP visibility."},
      {"icon": "🗺️", "title": "XML Sitemaps", "description": "Properly formatted sitemaps for efficient crawling."},
      {"icon": "🔒", "title": "HTTPS & Security", "description": "SSL implementation and security best practices."},
      {"icon": "🎯", "title": "Canonicalization", "description": "Fix duplicate content issues with proper canonical tags."}
    ],

    benefits: [
      {
        title: "Higher Search Rankings",
        description: "Achieve top positions for your target keywords and dominate search results."
      },
      {
        title: "Increased Organic Traffic",
        description: "Drive more qualified visitors to your website without paying for ads."
      },
      {
        title: "Better User Experience",
        description: "Optimizations that benefit both search engines and your users."
      },
      {
        title: "Measurable ROI",
        description: "Track rankings, traffic, and conversions with detailed reporting."
      }
    ],

    process: [
      {
        title: "Audit & Analysis",
        description: "Comprehensive analysis of current performance and opportunities."
      },
      {
        title: "Strategy Development",
        description: "Custom roadmap tailored to your business goals and market."
      },
      {
        title: "Implementation",
        description: "Execute optimizations with precision and best practices."
      },
      {
        title: "Monitor & Refine",
        description: "Continuous tracking and optimization for maximum results."
      }
    ],

    whyChoose: {
      title: "Expert SEO Specialists",
      description: "Our team has years of experience delivering results across industries. We follow white-hat practices and stay updated with the latest algorithm changes.",
      points: [
        {
          title: "Proven Track Record",
          description: "300%+ average traffic increase for our clients"
        },
        {
          title: "Transparent Reporting",
          description: "Monthly reports with clear KPIs and actionable insights"
        },
        {
          title: "Dedicated Support",
          description: "Direct access to your SEO specialist and account manager"
        }
      ]
    },

    relatedServices: [
      {"icon": "📝", "title": "On-Page SEO", "description": "Content optimization services", "link": "/services/seo/on-page"},
      {"icon": "🌐", "title": "Off-Page SEO", "description": "Authority and backlink building", "link": "/services/seo/off-page"},
      {"icon": "💻", "title": "Web Development", "description": "Custom website development", "link": "/services/web-development"}
    ]
  };

  return (
    <>
      <SubServiceTemplate {...pageData} />
      
            <SEO 
                title="Technical S E O Services" 
                description="Learn more about our Technical S E O services to grow your business online with Digi Network." 
                canonical="/seo/technical-seo" 
            />

    </>
  );
};

export default TechnicalSEO;
